import React from 'react';
import { Link } from 'react-router';

import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';

import PageImage from '../common/PageImage';
import PageQuote from '../common/PageQuote';
const pageImgSource = require('./leadership-comp.png');

const style = {
  button: {
    margin: "5px"
  },
  main: {
    margin: "20px 10px 20px 10px"
  }
};

const quote = "I don't think much of a person who is not wiser today than they were yesterday.";
const quoteBy = "Abraham Lincoln";

class LeadershipCompsPage extends React.Component {

  componentDidMount() {
    window.scrollTo(0,0);
  }

  render() {
    return (
      <Paper className="page-paper">
        <div className="page-container">
          <div className="row">
            <div className="page-banner-text">
              <div style={style.main} className="main-text">
                McDonald’s Leadership Competencies describe the knowledge, skills and abilities that are expected of all employees. Eight Leadership Competencies have been identified as the most critical capabilities our people must possess in order to drive the business
              </div>
            </div>
          </div>
          <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4">
                  <RaisedButton style={style.button} label="Communicates Effectively And Candidly" primary={true} fullWidth={true} />
                  <RaisedButton style={style.button} label="Elevates and Champions Talent" primary={true} fullWidth={true} />
                  <RaisedButton style={style.button} label="Is Customer Obsessed" primary={true} fullWidth={true} />
                  <Link to="leadership-comps/plans-and-acts-strategically">
                    <RaisedButton style={style.button} label="Plans & Acts Strategically" primary={true} fullWidth={true} />
                  </Link>
                  <RaisedButton style={style.button} label="Achieves through Teamwork" primary={true} fullWidth={true} />
                  <RaisedButton style={style.button} label="Leads through Influence" primary={true} fullWidth={true} />
                  <RaisedButton style={style.button} label="Leads Change & Innovation" primary={true} fullWidth={true} />
                  <RaisedButton style={style.button} label="Focuses on What Matters Most" primary={true} fullWidth={true} />
              </div>
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-8">
                <PageImage imgSource={pageImgSource}/>
                <PageQuote quote={quote} quoteBy={quoteBy} />
              </div>
          </div>
        </div>
      </Paper>
    );
  }
}

export default LeadershipCompsPage;



/** WEBPACK FOOTER **
 ** ./src/components/leadership-comps/LeadershipCompsPage.js
 **/